module.exports = __webpack_public_path__ + "img/icon-faq-plus.5ad7792b.svg";